import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const SpotifyModel = types.model({
  id: types.identifier,
  url: types.string,
});

export interface SpotifyInstance extends Instance<typeof SpotifyModel> {}
export type SpotifySnapshot = SnapshotIn<typeof SpotifyModel>;
